module.exports = __webpack_public_path__ + "img/CicekSepeti.0dde4284.png";